import { paths } from "../navigation/navigate";

const pagesConfig = {
  notLogged: [
    {
      navigationId: 0,
      path: paths.home,
      name: "Home",
      working: true,
    },
    {
      navigationId: 0,
      path: paths.guest,
      name: "GuestHome",
      working: true,
    },
    {
      navigationId: 3,
      path: paths.renter,
      name: "Renter",
      working: true,
    },
  ],
  logged: [
    {
      dontShow: true,
      pages: [
        {
          navigationId: 0,
          path: paths.home,
          name: "Home",
          working: true,
        },
        {
          navigationId: 0,
          path: paths.guest,
          name: "GuestHome",
          working: true,
        },
        {
          navigationId: 3,
          path: paths.renter,
          name: "Renter",
          working: true,
        },
      ],
    },
  ],
};
export default pagesConfig;
